/**
 * 순차 증가(Sequence) 번호 처리
 * @class SeqCalculator
 */
export default class SeqCalculator {
    private _seq = 0;
  
    public get seqNo(): number {
      return this._seq;
    }
  
    public getNextSeq(): number {
      this._seq += 1;
      return this._seq;
    }
  }
  